import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b42f0b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Date")
const _hoisted_2 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 4.5H17.25M3 9H12.75M3 13.5H8.25M13.5 12.75L17.25 9M17.25 9L21 12.75M17.25 9V21",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 4.5H17.25M3 9H12.75M3 13.5H12.75M17.25 9V21M17.25 21L13.5 17.25M17.25 21L21 17.25",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Name")
const _hoisted_9 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 4.5H17.25M3 9H12.75M3 13.5H8.25M13.5 12.75L17.25 9M17.25 9L21 12.75M17.25 9V21",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M3 4.5H17.25M3 9H12.75M3 13.5H12.75M17.25 9V21M17.25 21L13.5 17.25M17.25 21L21 17.25",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

import { computed, Ref, ref } from 'vue';

import { resume } from '@/plugins/resume';
import { usePaginatedResponse } from '@/utils/query';
import {
  useGetRootDeviceGroupsQuery,
} from '@/entities/device-group/hooks';

import {
  NkGroup,
  NkButtonLink,
  NkInlineModal,
  NkButton,
  NkEntry, LetterFilter, NkText,
} from '@/core/components';

import DeviceGroupAdd from '@/entities/device-group/components/form/DeviceGroupAdd.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceGroupRootEntry',
  setup(__props) {

const page = ref(1);
const order: Ref<{'order[name]'?: 'asc' | 'desc', 'order[createdAt]'?: 'asc' | 'desc'}> = ref({
  "order[createdAt]": 'desc' as const
});
const letter: Ref<string> = ref('');

const deviceGroupsRootQueryFilters: Ref = computed(() => {
  const filters: {
    page: number,
    'order[name]'?: 'asc' | 'desc',
    'order[createdAt]'?: 'asc' | 'desc'
    startWith?: string
  } = {
    page: page.value,
    ...order.value
  };

  if ( letter.value ) {
    filters.startWith = letter.value;
  }

  return filters;
});
const {
  data: deviceGroupsData,
  isLoading,
  refetch,
} = useGetRootDeviceGroupsQuery({}, deviceGroupsRootQueryFilters, {
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json',
  },
});
const { data: deviceGroups, meta } = usePaginatedResponse(deviceGroupsData);

// eslint-disable-next-line no-unsafe-optional-chaining
const isSinglePage = computed(() => !!(meta.value?.totalItems && meta.value?.itemsPerPage && (meta.value?.totalItems / meta.value?.itemsPerPage) <= 1));

const handlePageChange = (pageNumber: number) => {
  page.value = pageNumber;
  refetch.value();
};

const handleLetterChange = (letterSelected: string) => {
  letter.value = letterSelected;
  page.value = 1;
  refetch.value();
}

const handleOrderChange = (field: 'name' | 'createdAt') => {
  if(order.value[`order[${field}]`] && order.value[`order[${field}]`] === 'asc') {
    order.value[`order[${field}]`] = 'desc';
  } else if(order.value[`order[${field}]`]) {
    order.value[`order[${field}]`] = 'asc';
  } else {
    order.value = {};
    order.value[`order[${field}]`] = 'asc';
  }

  refetch.value();
}

return (_ctx: any,_cache: any) => {
  const _component_ElPagination = _resolveComponent("ElPagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(NkEntry), {
    title: _ctx.$t('misc.parks'),
    position: "left"
  }, {
    actions: _withCtx(() => [
      _createVNode(_unref(NkGroup), { spacing: "4" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "sort-text",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOrderChange('createdAt')))
          }, [
            _createVNode(_unref(NkText), {
              as: "p",
              type: "semibold-xxs2",
              uppercase: ""
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("i", {
              class: _normalizeClass({'sort-active': order.value['order[createdAt]']})
            }, [
              (order.value['order[createdAt]'] === 'desc')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
            ], 2)
          ]),
          _createElementVNode("div", {
            class: "sort-text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOrderChange('name')))
          }, [
            _createVNode(_unref(NkText), {
              as: "p",
              type: "semibold-xxs2",
              uppercase: ""
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createElementVNode("i", {
              class: _normalizeClass({'sort-active': order.value['order[name]']})
            }, [
              (order.value['order[name]'] === 'desc')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
                : (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
            ], 2)
          ])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_unref(NkGroup), { spacing: 5 }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deviceGroups), (deviceGroup) => {
            return (_openBlock(), _createBlock(_unref(NkButtonLink), {
              key: deviceGroup.id,
              to: {name: 'visionair-device-group', params: {
          deviceGroup: deviceGroup.id,
        }},
              title: deviceGroup.name
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(resume)(deviceGroup.name, 60)), 1)
              ]),
              _: 2
            }, 1032, ["to", "title"]))
          }), 128)),
          _createVNode(_unref(NkInlineModal), {
            title: _ctx.$t('device_group.form.title.add'),
            class: "max-w-screen-md"
          }, {
            content: _withCtx(({close}) => [
              _createVNode(DeviceGroupAdd, { onSubmitted: close }, null, 8, ["onSubmitted"])
            ]),
            default: _withCtx(() => [
              (_ctx.$store.getters['connection/isGranted'](['device_group_create']))
                ? (_openBlock(), _createBlock(_unref(NkButton), {
                    key: 0,
                    circle: "",
                    size: "sm",
                    icon: "NkPlus",
                    class: "text-white"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      })), [
        [_directive_loading, _unref(isLoading)]
      ]),
      _createVNode(_unref(LetterFilter), {
        "model-value": letter.value,
        "onUpdate:modelValue": handleLetterChange
      }, null, 8, ["model-value"]),
      (_unref(meta).totalItems && _unref(meta).itemsPerPage)
        ? (_openBlock(), _createBlock(_component_ElPagination, {
            key: 0,
            "current-page": page.value,
            layout: "prev, pager, next",
            "hide-on-single-page": _unref(isSinglePage),
            total: _unref(meta).totalItems,
            "page-size": _unref(meta).itemsPerPage,
            onCurrentChange: handlePageChange
          }, null, 8, ["current-page", "hide-on-single-page", "total", "page-size"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})